/**
 * The Equipment panel's slot rows, in paper-doll order
 * (q-p2triage-fe-player-trust-and-ux). A hand-kept list here once lacked `legs`,
 * so worn leggings never showed; the test pins this to every live
 * `EQUIPMENT_SLOTS` name in shared content types. Pure.
 */

import type { EquipmentSlot } from '@great-cloud/shared/client';

export const EQUIP_SLOTS: readonly EquipmentSlot[] = [
  'head',
  'chest',
  'hands',
  'legs',
  'feet',
  'mainhand',
  'offhand',
  'trinket',
];

/**
 * The paperdoll's rows: what THIS character wears. The inventory snapshot is
 * account-wide, so `equipped` rows of every character share one array and
 * `locationRef` names the wearer (the avatar's `equippedItemsForCharacter` rule).
 * Filtering on `location` alone showed a sibling character's gear in a slot (H-1437).
 * Before hello (`characterId` null) nothing is worn yet.
 */
export function wornByCharacter<T extends { location: string; locationRef: string | null }>(
  items: readonly T[],
  characterId: number | null,
): T[] {
  if (characterId === null) return [];
  const self = String(characterId);
  return items.filter((i) => i.location === 'equipped' && i.locationRef === self);
}
